// extracted by mini-css-extract-plugin
export default {"form":"gIPPJ","button":"DpO6U","chip":"adL4x","titles":"Ppa6y","textarea":"ENFNR","paid-label":"rNNrK","input-form":"sDz8t","collection-input":"cbAeH","collection-select":"ET5fr"};